/**
 * CT Split Hero v5 — Carousel
 * Vanilla JS, IIFE encapsulated, zero global scope pollution, zero dependencies.
 * Loaded with defer only when carousel_slide blocks exist in the section.
 */
(function () {
  'use strict';

  var TRACK_SEL   = '.ct-hero-carousel__track';
  var SLIDE_SEL   = '.ct-hero-carousel__slide';
  var DOT_SEL     = '.ct-hero-carousel__dot';
  var PREV_SEL    = '.ct-hero-carousel__arrow--prev';
  var NEXT_SEL    = '.ct-hero-carousel__arrow--next';
  var ACTIVE_CLS  = 'is-active';
  var FADE_CLS    = 'ct-hero-carousel--fade';

  function initCarousel(root) {
    var track      = root.querySelector(TRACK_SEL);
    var slides     = Array.prototype.slice.call(root.querySelectorAll(SLIDE_SEL));
    var dots       = Array.prototype.slice.call(root.querySelectorAll(DOT_SEL));
    var prevBtn    = root.querySelector(PREV_SEL);
    var nextBtn    = root.querySelector(NEXT_SEL);
    var total      = slides.length;
    var isFade     = root.classList.contains(FADE_CLS);
    var autoplay   = root.dataset.autoplay === 'true';
    var speed      = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var pauseHover = root.dataset.pauseOnHover === 'true';
    var current    = 0;
    var timer      = null;
    var isAnimating = false;

    if (total <= 1) return;

    /* ── Initial aria-hidden on non-active slides ─────────── */
    slides.forEach(function (slide, i) {
      slide.setAttribute('aria-hidden', i !== 0 ? 'true' : 'false');
    });

    /* ── Go to slide n ────────────────────────────────────── */
    function goTo(n) {
      if (isAnimating) return;
      var target = ((n % total) + total) % total;
      if (target === current) return;

      isAnimating = true;
      var prev = current;
      current = target;

      if (isFade) {
        slides[prev].classList.remove(ACTIVE_CLS);
        slides[prev].setAttribute('aria-hidden', 'true');
        slides[current].classList.add(ACTIVE_CLS);
        slides[current].setAttribute('aria-hidden', 'false');
      } else {
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i !== current ? 'true' : 'false');
        });
      }

      /* Update dots */
      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle(ACTIVE_CLS, active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      /* Unlock after transition completes */
      setTimeout(function () { isAnimating = false; }, 520);
    }

    /* ── Autoplay ─────────────────────────────────────────── */
    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* ── Arrow buttons ────────────────────────────────────── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay(); goTo(current - 1); startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay(); goTo(current + 1); startAutoplay();
      });
    }

    /* ── Dot buttons ──────────────────────────────────────── */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        if (!isNaN(idx)) { stopAutoplay(); goTo(idx); startAutoplay(); }
      });
    });

    /* ── Keyboard navigation ──────────────────────────────── */
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stopAutoplay(); goTo(current - 1); startAutoplay(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); goTo(current + 1); startAutoplay(); }
    });

    /* ── Touch / swipe (50px threshold, ignores vertical) ─── */
    var touchStartX = 0;
    var touchStartY = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 50 || Math.abs(dy) > Math.abs(dx)) return;
      stopAutoplay();
      goTo(dx < 0 ? current + 1 : current - 1);
      startAutoplay();
    }, { passive: true });

    /* ── Pause on hover / focus ───────────────────────────── */
    if (pauseHover) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin',    stopAutoplay);
      root.addEventListener('focusout',   startAutoplay);
    }

    /* ── Boot ─────────────────────────────────────────────── */
    startAutoplay();
  }

  /* ── Init all carousels on the page ──────────────────────── */
  function initAll() {
    var carousels = document.querySelectorAll('[data-carousel]');
    for (var i = 0; i < carousels.length; i++) {
      initCarousel(carousels[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor live reload support */
  document.addEventListener('shopify:section:load', function (e) {
    var carousels = e.target.querySelectorAll('[data-carousel]');
    for (var i = 0; i < carousels.length; i++) {
      initCarousel(carousels[i]);
    }
  });

})();
